import { CustomColumn } from '../../../../types/components/tables/tableTypes';
import type { MrmPayload } from '../../../../api/rs-hg/risk/mrm.types';

export interface MarketRiskStatusData {
  zeroToPointFive: string;
  pointFiveToTwo: string;
  twoToFive: string;
  fiveToTen: string;
  tenToFifteen: string;
  fifteenToTwentyFive: string;
  twentyFiveUp: string;
}

/**
 * The titles are empty because we hide the header
 */
export const marketRiskStatusColumns: CustomColumn<MarketRiskStatusData>[] = [
  {
    field: 'zeroToPointFive',
    title: '1',
  },
  {
    field: 'pointFiveToTwo',
    title: '2',
  },
  {
    field: 'twoToFive',
    title: '3',
  },
  {
    field: 'fiveToTen',
    title: '4',
  },
  {
    field: 'tenToFifteen',
    title: '5',
  },
  {
    field: 'fifteenToTwentyFive',
    title: '6',
  },
  {
    field: 'twentyFiveUp',
    title: '7',
  },
];

export interface HistoricalMrmData {
  lowerBound: number;
  upperBound: number;
  srri: number;
  date: string;
}

export function generateMrmLineChartData(
  payload: MrmPayload,
): HistoricalMrmData[] {
  try {
    const timeSeriesData =
      payload.time_series_data ?? payload.data2?.time_series_data;

    if (!timeSeriesData?.length) return [];

    const dataForUse = [...timeSeriesData];
    dataForUse.shift();

    return dataForUse.map((el) => {
      const [date, srri, lowerBound, upperBound] = el;
      return {
        date,
        srri: Number(srri),
        lowerBound: Number(lowerBound),
        upperBound: Number(upperBound),
      };
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
}
